import React, { useEffect, useRef, CSSProperties } from "react";
import styled from "@emotion/styled";
import { systemWidth } from "@kaltura/mediaspace-shared-styled";

export interface HtmlOnlyProps {
    html: string;
    maxHeight?: CSSProperties["maxHeight"];
    isFullWidth?: boolean;
}

const StyledHtmlOnlyWrapper = styled(
    "div",
    {
        shouldForwardProp(propName: PropertyKey): boolean {
            return propName !== "isFullWidth";
        },
    }
)<{ isFullWidth?: boolean }>(({ theme, isFullWidth }) => ({
    "&": !isFullWidth && systemWidth({ theme }),
    display: "flex",
    justifyContent: "center",
}));

const StyledHtmlOnly = styled(
    "div",
    {
        shouldForwardProp(propName: PropertyKey): boolean {
            return propName !== "maxHeight";
        },
    }
)<{ maxHeight?: CSSProperties["maxHeight"] }>(({ maxHeight }) => ({
    display: "inline-block",
    overflowY: "auto",
    maxHeight: maxHeight,
    width: "100%",
}));

/**
 *  HtmlOnly component renders html in the homepage
 */
export const HtmlOnly = (props: HtmlOnlyProps) => {
    const { html, maxHeight = "250px", isFullWidth = false } = props;
    const htmlOnlyRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // dangerously parse html with script tags inside html-only div
        const htmlDocumentFragment = document.createRange().createContextualFragment(html);
        htmlOnlyRef.current?.appendChild(htmlDocumentFragment);
    }, [html]);

    return (
        <StyledHtmlOnlyWrapper
            className={"chromatic-ignore kms-ds-homepage-component-htmlonly"}
            isFullWidth={isFullWidth}
        >
            <StyledHtmlOnly ref={htmlOnlyRef} maxHeight={maxHeight} />
        </StyledHtmlOnlyWrapper>
    );
};

export default HtmlOnly;
